import React, { Component } from 'react';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import { Link, withRouter } from 'react-router'
import { Field, FieldArray, reset } from 'redux-form'
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, Button, DropdownButton, MenuItem, FieldGroup, Input } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Selection from '../Common/selection'
import { InputField, DisabledInputField } from '../Common/inputField';
import IsActive from '../Common/isActive';
import AfterAddonField from '../Common/afterAddonField';
import Spinner from '../Widgets/spinner';
import CustomerForm from '../../containers/Customers/customerForm';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import WholesaleModal from '../../containers/Sales/wholesaleModal';
import ReactDOM from 'react-dom';

import { Translate, Localize } from 'react-redux-i18n';


class WholesaleOrderForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            cellSelectEnabled: true,

            customerOpen: false,
            batchOpen: false,
            dirty: false,
            favoriteItemsOpen: true,
            previousOrdersOpen: false,
            promotionsOpen: false,
            currentCustomer: null,
            currentCustomerName: null,
            customersWithFavorites: [],
            selectedItemName: '',
            selectedItemNumber: '',
            totalPrice: null,
            finalWeight: null,

            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
            inventoryInput: null,

            inventories: {
              rows: [],
              allRows: [],
              currString: null,
              selectedRows: null,
              sortColumn: null,
              sortDirection: null,
            },

            favorites: {
              rows: [],
              selectedRows: null,
              sortColumn: null,
              sortDirection: null,
            },

            previousOrders: {
              rows: [],
              selectedRows: null,
              sortColumn: null,
              sortDirection: null,
            },

            promotions: {
              rows: [],
              selectedRows: null,
              sortColumn: null,
              sortDirection: null,
            }
        };
        this.openCustomer = this.openCustomer.bind(this);
        this.closeCustomer = this.closeCustomer.bind(this);
        this.moveToSO = this.moveToSO.bind(this);
        this.removeFromSO = this.removeFromSO.bind(this);
        this.openChooseFromBatch = this.openChooseFromBatch.bind(this);
        this.closeChooseFromBatch = this.closeChooseFromBatch.bind(this);
    }

    componentWillMount() {
    }

    componentDidMount() {
        const { currentSalesOrder } = this.props;
        if (currentSalesOrder)
            this.props.fetchSalesOrderDetail(currentSalesOrder.SalesOrder_id)
            .then(() => {
                this.props.fetchInventories();
                this.props.fetchCustomers();
                this.props.fetchCustomersWithFavorites();
                this.props.fetchPreviousOrders();
                this.props.fetchPromotions();
            })
        else {
            this.props.fetchInventories();
            this.props.fetchCustomers();
            this.props.fetchCustomersWithFavorites();
            this.props.fetchPreviousOrders();
            this.props.fetchPromotions();
        }
        // making a leaving hook to confirm leaving
        this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    }

    componentDidUpdate() {
        reset('productForm');
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dirty != this.props.dirty) {
            this.setState({
                dirty: nextProps.dirty
            });
        }

        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            let inventoryItems = [...nextProps.inventories];

            // inventoryItems.map(item => {
            //   item.Weight = item.ProductNum.NetWeight;
            //   item.IsOverSaleable = item.ProductNum.IsOverSaleable;
            //   item.Name = item.ProductNum.Name;
            //   item.Ordered = item.Purchased;
            //   item.Price = item.RefPurchasingPrice;
            //   item.ItemNum = item.ProductNum.ProductNum;
            // })
            let inventories = {...this.state.inventories, allRows: inventoryItems, rows: inventoryItems};
            console.log("inventories", inventories);
            this.setState({ inventories });
        }

        if (nextProps.inventoryIdValue && nextProps.inventoryIdValue != this.props.inventoryIdValue) {
            let filteredRows = this.state.inventories.allRows.filter(function (obj) {
              return String(obj.ProductNum.ProductNum).includes(String(nextProps.inventoryIdValue));
            })

            let inventories = {...this.state.inventories, rows: filteredRows};
            this.setState({inventories});


            const index = _.findIndex(filteredRows, { 'ItemNum': nextProps.inventoryIdValue });
            if (index > -1) {
              console.log(filteredRows[index].ProductNum.Name, nextProps.inventoryIdValue);
              this.setState({
                selectedItemName: filteredRows[index].ProductNum.Name,
                selectedItemNumber: nextProps.inventoryIdValue
              });
            }
        }

        if (nextProps.customersWithFavorites && nextProps.customersWithFavorites != this.props.customersWithFavorites) {
          const index = _.findIndex(nextProps.customersWithFavorites, { 'Customer_id': this.state.currentCustomer });
          if (index != -1) {
            let newFavorites = [...nextProps.customersWithFavorites[index].Sales_FavoriteList_Lines];

            this.state.rows.map(row => {
              var check = _.findIndex(newFavorites, { 'ProductNum': row.ProductNum });
              if (check != -1) {
                newFavorites[index].inList = true;
              }
            });

            let favorites = {...this.state.favorites, rows: newFavorites}
            this.setState({favorites});
          }
        }

        if (nextProps.previousOrders && nextProps.previousOrders != this.props.previousOrders) {
            var previousOrders = {...this.state.previousOrders, rows: nextProps.previousOrders};
            this.setState({previousOrders});
        }

        if (nextProps.promotions && nextProps.promotions != this.props.promotions) {
            var promotions = {...this.state.promotions, rows: nextProps.promotions};
            this.setState({promotions});
        }

        if (nextProps.customerChosen && nextProps.customerChosen != this.props.customerChosen) {
            const index = _.findIndex(this.props.customersWithFavorites, { 'Customer_id': nextProps.customerChosen.value });
            if (index != -1) {
              var newFavRows = this.props.customersWithFavorites[index].Sales_FavoriteList_Lines;
              this.state.rows.map(row => {
                let rowPos = _.findIndex(newFavRows, { 'ProductNum': row.ProductNum})
                if (rowPos != -1) {
                  newFavRows[rowPos].inList = true;
                }
              });

              var favorites = {...this.state.favorites, rows: newFavRows};
              this.setState({favorites, currentCustomer: nextProps.customerChosen.value, currentCustomerName: nextProps.customerChosen.label});
            }
        }
    }

    routerWillLeave(nextLocation) {
        if (this.state.dirty) return <Translate value="work_not_saved_warning" />
    }

    // Helper function to pop up the add payment term function

    openCustomer() { this.setState({ customerOpen: true }); }

    closeCustomer() { this.setState({ customerOpen: false }); }

    openChooseFromBatch() {
      const index = _.findIndex(this.state.inventories.allRows, { 'ProductNum': this.state.selectedItemNumber });
      console.log("item to select", this.state.inventories.allRows[index]);
      if (this.state.inventories.allRows[index].InStock > 0) {
        this.setState({batchOpen: true});
      } else {
        alert("Item has none in stock!");
      }
    }

    closeChooseFromBatch() { this.setState({batchOpen: false}); }

    handleFormSubmit(formProps) {
        this.setState({ dirty: false });
        if (!this.props.currentSalesOrder) this.props.createSalesOrder(formProps);
        else {
          if(!this.checkPermission("change_sales_order"))
            this.props.editSalesOrder(formProps);
          else
            alert("You have no permission!");
        }
    }

    title() {
        if (!this.props.params.id) {
            return <h3><Translate value="create_a_new_sales_order" /></h3>
        }
        return <h3><Translate value="edit_sales_order" /> {this.props.params.id}</h3>
    }

    // Render the customers selection, including name and number.
    renderCustomers() {
        if (this.props.customersIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
        else {
            let customerNameOptions = this.getCustomerNameOptions();
            let customerNumOptions = this.getCustomerNumOptions();
            return (
                <div>
                    <Row>
                        <Col sm={ 12 }>
                            <label><Translate value="customer_name" />: </label>
                            <Field name="Customer_id" component={Selection} options={customerNameOptions }/>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col sm={ 12 }>
                            <label><Translate value="customer_no" />: </label>
                            <Field name="Customer_id" component={Selection} options={customerNumOptions}/>
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    getCustomerNameOptions() {
        var customerOptions = [];
        this.props.customers.map(customer => {
            customerOptions.push({ value: customer.Customer_id, label: customer.Name })
        });
        return customerOptions;
    }

    getCustomerNumOptions() {
        var customerOptions = [];
        this.props.customers.map(customer => {
            customerOptions.push({ value: customer.Customer_id, label: customer.CustomerNum })
        });
        return customerOptions;
    }

    // Render the product selection
    renderInventories() {
        if (this.props.inventoriesIsLoading) return <Spinner/> // If payment term is loading, show a spinner.
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.inventories);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var inventories = {...this.state.inventories, sortColumn: sortColumn, sortDirection: sortDirection};
                this.setState({inventories});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.inventories.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                let inventories = {...this.state.inventories, filters: newFilters};
                this.setState({ inventories });
            }

            // Handle the row select function

            const onRowClick = (rowIdx, row) => {
              let rows = this.state.inventories.rows;
              rows.map(row => {
                row.isSelected = false;
              });
              rows[rowIdx] = Object.assign({}, row, {isSelected: true});
              let inventories = {...this.state.inventories, rows: rows};
              this.setState({inventories, cellSelectEnabled: false, selectedItemName: row.Name, selectedItemNumber: row.ProductNum, refPrice: row.Price});
            }

            const onRowsSelected = (rows) => {
                let newRows = this.state.inventories.rows;
                rows.map (r => {
                  newRows[r.rowIdx].isSelected = true;
                });
                let inventories = {...this.state.inventories, rows: newRows};
                this.setState({ inventories });
            }

            const onRowsDeselected = (rows) => {
                let newRows = this.state.inventories.rows;
                rows.map (r => {
                  newRows[r.rowIdx].isSelected = false;
                });
                let inventories = {...this.state.inventories, rows: newRows};
                this.setState({ inventories });
            }

            const onKeyDown = (e) => {
                console.log(this);
                console.log(e);
                let currentSelected = null;
                if (e.keyCode === 40 || e.keyCode === 38) {
                  e.preventDefault();

                  let rows = [];
                  this.state.inventories.rows.forEach((r) =>{
                    if (r.isSelected == true) {
                      currentSelected = r.id;
                    }
                    rows.push(Object.assign({}, r, {isSelected: false}));
                  });

                  let index = _.findIndex(rows, { 'id': currentSelected });
                  if (e.keyCode === 40) {
                    if (index == rows.length - 1)
                      return;
                    rows[index + 1].isSelected = true;
                  } else {
                    if (index == 0)
                      return;
                    rows[index - 1].isSelected = true;
                  }
                  let inventories = {...this.state.inventories, rows: rows}
                  this.setState({ inventories });
                } else if (e.keyCode === 13) {
                  console.log("entered block for enter");
                  e.preventDefault();

                  this.state.inventories.rows.forEach((r) =>{
                    if (r.isSelected == true) {
                      currentSelected = r;
                    }
                  });
                  console.log(currentSelected)
                  if (currentSelected != null) {
                    this.setState({selectedItemName: currentSelected.Name, selectedItemNumber: currentSelected.ItemNum, refPrice: currentSelected.Price}, this["chooseFromBatch"].props.onClick);
                  }
                }
            }

            var RowRenderer = React.createClass({
             getRowStyle: function() {
               return {
                 color: this.getRowBackground(),
               }
             },
             getRowBackground: function() {
               if (this.props.row.inList == true) {
                 return 'blue';
               } else if (this.props.row.IsOverSaleable == false && this.props.row.InStock == 0){
                 return 'red';
               } else {
                 return null;
               }
             },
             render: function() {
               //here we are just changing the style
               //but we could replace this with anything we liked, cards, images, etc
               //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
               return (<div style={this.getRowStyle()}><ReactDataGrid.Row ref="row" {...this.props}/></div>)
             }
            });

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="item_no" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'Name',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                },
                {
                    key: 'PreSale',
                    name: <Translate value="presale" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'InStock',
                    name: <Translate value="instock" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'Purchased',
                    name: <Translate value="ordered" />,
                    resizable: true,
                    sortable: true,
                }
            ]

            return (
              <Row>
                <Row>
                    <Col sm={ 12 }>
                        <label><Translate value="inventory_number" />: </label>
                        <Field name="Inventory_id" withRef={true} onKeyPress={(event) => this.handleInventoryNumKeyPress(event)} ref="inventory" component={ InputField }/>
                    </Col>
                </Row>
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="WholesaleOrderForm-dataGrid1">
                    <ReactDataGrid
                        ref="reactDataGrid"
                        style={{ height: 250 }}
                        rowKey='Product_id'
                        enableCellSelect={this.state.cellSelectEnabled}
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        onRowUpdated={this.handleRowUpdated}
                        onRowClick={onRowClick}
                        rowRenderer={RowRenderer}
                        enableRowSelect='single'
                        rowSelection={{
                          showCheckbox: false,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }}
                        onGridKeyDown={onKeyDown} />
                </div></Col></Row>
              </Row>
            )
        }
    }

    getInventoryNameOptions() {
        var inventoryOptions = [];
        this.props.inventories.map(inventory => {
            inventoryOptions.push({ value: inventory.id, label: inventory.id })
        });
        return inventoryOptions;
    }

    getInventoryNumOptions() {
        var inventoryOptions = [];
        this.props.inventories.map(inventory => {
            inventoryOptions.push({ value: inventory.id, label: inventory.ProductNum.ProductNum })
        });
        return inventoryOptions;
    }

    favoriteItemsHeader() {
        return (
            <div onClick={ () => this.setState({ favoriteItemsOpen: !this.state.favoriteItemsOpen }) } >
                <label style={{ cursor: "pointer" }} ><Translate value="favorite_items" /></label>
            </div>
        )
    }

    previousOrdersHeader() {
        return (
            <div onClick={ () => this.setState({ previousOrdersOpen: !this.state.previousOrdersOpen, promotionsOpen: false}) } >
                <label style={{ cursor: "pointer" }} ><Translate value="previous_orders" /></label>
            </div>
        )
    }

    promotionsHeader() {
        return (
            <div onClick={ () => this.setState({ promotionsOpen: !this.state.promotionsOpen, previousOrdersOpen: false}) } >
                <label style={{ cursor: "pointer" }} ><Translate value="promotions" /></label>
            </div>
        )
    }

    renderPreviousOrders() {
        if (this.props.previousOrdersIsLoading && !this.props.previousOrdersError) return <Spinner/>
        else if (this.props.previousOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.previousOrdersError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.previousOrders);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var previousOrders = {...this.state.previousOrders, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({previousOrders});
            }

            const onRowSelect = rows => {
                var previousOrders = {...this.state.previousOrders, selectedRows: rows};
                this.setState({previousOrders});
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            // Column difinition

            const columns = [
              {
                  key: 'ProductName',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true
              },
              {
                  key: 'PreSale',
                  name: <Translate value="presale" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true
              },
              {
                  key: 'InStock',
                  name: <Translate value="instock" />,
                  resizable: true,
                  sortable: true,
                  width: 80
              },
              {
                  key: 'Ordered',
                  name: <Translate value="quantity" />,
                  resizable: true,
                  sortable: true,
                  width: 80
              },
              {
                  key: 'Price',
                  name: <Translate value="price" />,
                  resizable: true,
                  sortable: true,
                  width: 100
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="WholesaleOrderForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='Product_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        enableRowSelect='multi'
                        minHeight={this.state.tableHeight}
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    renderFavorites() {
        if (this.props.favoritesIsLoading && !this.props.favoritesError) return <Spinner/>
        else if (this.props.favoritesError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.favoritesError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.favorites);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var favorites = {...this.state.favorites, sortColumn: sortColumn, sortDirection: sortDirection };
                this.setState({favorites});
            }

            const onRowSelect = rows => {
                var POs = {...this.state.favorites, selectedRows: rows};
                this.setState({favorites});
            }

            const onRowClick = (rowIdx, row) => {
                this.setState({selectedItemName: row.ProductName, selectedItemNumber: row.ProductNum})
            }

            var RowRenderer = React.createClass({
             getRowStyle: function() {
               return {
                 color: this.getRowBackground()
               }
             },
             getRowBackground: function() {
               if (this.props.row.inList == true) {
                 return 'blue';
               } else if (this.props.row.IsOverSaleable == false && this.props.row.InStock == 0){
                 return 'red';
               } else {
                 return null;
               }
             },
             render: function() {
               //here we are just changing the style
               //but we could replace this with anything we liked, cards, images, etc
               //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
               return (<div style={this.getRowStyle()}><ReactDataGrid.Row ref="row" {...this.props}/></div>)
             }
            });

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success">Enabled</span>;
                    else return <span className="label label-danger">Disable</span>;
                }
            });

            // Column difinition

            const columns = [
              {
                  key: 'ProductName',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true
              },
              {
                  key: 'PreSale',
                  name: <Translate value="presale" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true
              },
              {
                  key: 'InStock',
                  name: <Translate value="instock" />,
                  resizable: true,
                  sortable: true,
                  width: 80
              },
              {
                  key: 'Ordered',
                  name: <Translate value="quantity" />,
                  resizable: true,
                  sortable: true,
                  width: 80
              },
              {
                  key: 'Price',
                  name: <Translate value="price" />,
                  resizable: true,
                  sortable: true,
                  width: 100
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="WholesaleOrderForm-dataGrid3">
                    <ReactDataGrid
                        rowKey='Product_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect}
                        onRowClick={onRowClick}
                        rowRenderer={RowRenderer}
                        />
                </div></Col></Row>
            )
        }
    }

    renderPromotions() {
        if (this.props.promotionsAreLoading && !this.props.promotionsError) return <Spinner/>
        else if (this.props.promotionsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.promotionsError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.promotions);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var promotions = {...this.state.promotions, sortColumn: sortColumn, sortDirection: sortDirection};
                this.setState({promotions});
            }

            const onRowSelect = rows => {
                var POs = {...this.state.promotions, selectedRows: rows};
                this.setState({promotions});
            }


            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success">Enabled</span>;
                    else return <span className="label label-danger">Disable</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    width: 120,
                    filterable: true
                },
                {
                    key: 'PreSale',
                    name: <Translate value="presale" />,
                    resizable: true,
                    sortable: true,
                    width: 80,
                    filterable: true
                },
                {
                    key: 'InStock',
                    name: <Translate value="instock" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
                {
                    key: 'Ordered',
                    name: <Translate value="ordered" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
                {
                    key: 'Price',
                    name: <Translate value="price" />,
                    resizable: true,
                    sortable: true,
                    width: 100
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="WholesaleOrderForm-dataGrid4">
                    <ReactDataGrid
                        rowKey='Product_id'
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        enableRowSelect='multi'
                        minHeight={this.state.tableHeight}
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    renderTable() {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const onRowsSelected = (rows) => {
            let newRows = this.state.rows;
            rows.map (r => {
              newRows[r.rowIdx].isSelected = true;
            });
            this.setState({...this.state, rows: newRows});
        }

        const onRowsDeselected = (rows) => {
            let newRows = this.state.rows;
            rows.map (r => {
              newRows[r.rowIdx].isSelected = false;
            });
            this.setState({...this.state, rows: newRows});
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNameFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.Name}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNumFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        // Column difinition

        const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="product_num" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true
            },
            {
                key: 'ProductName',
                name: <Translate value="product_name" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'ProductDescription',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
                width: 100,
            },
            {
                key: 'Quantity',
                name: <Translate value="quantity" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'ProductUnitOfMeasure',
                name: <Translate value="unit_of_measure" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'UnitPrice',
                name: <Translate value="unit_price" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'Total',
                name: <Translate value="total_price" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'Weight',
                name: <Translate value="weight" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'Batch_PONum',
                name: <Translate value="batch_num" />,
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            }
        ]

        return (
            <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="WholesaleOrderForm-dataGrid5">
                <ReactDataGrid
                    style={{ height: 250 }}
                    rowKey='Batch_PONum'
                    onGridSort={handleGridSort}
                    toolbar={<Toolbar enableFilter={true}/>}
                    onAddFilter={handleFilterChange}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    enableRowSelect='multi'
                    onRowUpdated={this.handleRowUpdated}
                    rowSelection={{
                      showCheckbox: true,
                      enableShiftSelect: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}/>
            </div></Col></Row>
        )
    }

    moveToSO(Rows) {
      let newRows = this.state.rows;
      let updatedInventories = this.state.inventories.allRows;
      let updatedFavorites = this.state.favorites.rows;
      let ProductNum;
      let validEntry = false;

      Rows.map(row => {
        ProductNum = row.ProductNum;
        if(row.Total > 0) {
          row.isSelected = false;
          if(row.BatchAmount < row.Quantity) {
            alert("Not enough of " + row.ProductName + " of batch " + row.Batch_PONum + " in stock!");
          } else {
            validEntry = true;
            newRows.push(row);
          }
        }
      });

      if (validEntry) {
        var index = _.findIndex(updatedInventories, {'ItemNum': ProductNum});
        if (index != -1) {
          updatedInventories[index].inList = true;
        }

        index = _.findIndex(updatedFavorites, {'ProductNum': ProductNum});
        if (index != -1) {
          updatedFavorites[index].inList = true;
        }

        let totalPrice = 0;
        let finalWeight = 0;
        newRows.map(row => {
          totalPrice = totalPrice + parseInt(row.Total);
          finalWeight = finalWeight + parseInt(row.Weight);
        })

        let inventories = {...this.state.inventories, allRows: updatedInventories};
        this.setState({inventories, rows: newRows, totalPrice, finalWeight})
      }
    }

    renderSelectedItem() {
      return (
        <div>
          <Row>
            <Col sm={ 12 }>
              <Row>
                <Col sm={ 3 }>
                  <label><Translate value="item_no" /></label>
                </Col>
                <Col sm={ 3 }>
                    <label className="col-sm-5 centerStyle">{this.state.selectedItemNumber}</label>
                </Col>
                <Col sm={ 3 }>
                  <label><Translate value="item_name" /></label>
                </Col>
                <Col sm={ 3 }>
                  <label className="col-sm-5 centerStyle">{this.state.selectedItemName}</label>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )
    }

    removeFromSO() {
        let updatedRows = this.state.rows;
        let updatedSelectedRows = this.state.selectedRows;
        let updatedInventories = this.state.inventories.allRows;
        let updatedFavorites = this.state.favorites.rows;
        let totalPrice = 0;
        let finalWeight = 0;

        updatedRows.map(row => {
            if (row.isSelected == true) {
              var index = _.findIndex(updatedInventories, {'ItemNum': row.ProductNum});
              if (index != -1) {
                updatedInventories[index].inList = false;
              }

              index = _.findIndex(updatedFavorites, {'ProductNum': row.ProductNum});
              if (index != -1) {
                updatedFavorites[index].inList = false;
              }
            }
        });

        updatedRows.map(row => {
            if (row.isSelected != true) {
              var index = _.findIndex(updatedInventories, {'ItemNum': row.ProductNum});
              if (index != -1) {
                updatedInventories[index].inList = true;
              }

              index = _.findIndex(updatedFavorites, {'ProductNum': row.ProductNum});
              if (index != -1) {
                updatedFavorites[index].inList = true;
              }
            }
        });

        updatedRows = updatedRows.filter(function (obj) {
          return obj.isSelected == false || obj.isSelected == null;
        });

        updatedRows.map(row => {
            totalPrice += row.TotalPrice;
            finalWeight += row.Weight;
        });

        let inventories = {...this.state.inventories, allRows: updatedInventories};
        let favorites = {...this.state.inventories, rows: updatedFavorites};
        this.setState({inventories, favorites, rows: updatedRows, totalPrice, finalWeight});
    }

    formatDate(date) {
      let formattedDate = date.getFullYear() + '-';
      if (date.getMonth() < 9) {
        formattedDate += '0' + date.getMonth()+1 + '-';
      } else {
        formattedDate += date.getMonth()+1 + '-';
      }


      if (date.getDate() < 9) {
        formattedDate += '0' + date.getDate() + 'T';
      } else {
        formattedDate += date.getDate() + 'T';
      }

      if (date.getHours() < 9) {
        formattedDate += '0' + date.getHours() + ':';
      } else {
        formattedDate += date.getHours() + ':';
      }

      if (date.getMinutes() < 9) {
        formattedDate += '0' + date.getMinutes() + ':';
      } else {
        formattedDate += date.getMinutes() + ':';
      }

      if (date.getSeconds < 9) {
        formattedDate += '0' + date.getSeconds();
      } else {
        formattedDate += date.getSeconds();
      }
      return formattedDate;
    }

    addNewSalesOrder() {
      let { createSalesOrder, description, orderDate, dispatchDate, documentDate } = this.props;
      let newOrder = {};
      let Batch_Order_Lines = [];
      this.state.rows.map(row => {
        Batch_Order_Lines.push(row);
      });
      const index = _.findIndex(this.props.customers, { 'Customer_id': this.state.currentCustomer });
      newOrder.Batch_Order_Lines = Batch_Order_Lines;
      newOrder.IsWholesale = true;
      newOrder.Deliver_Customer_id = this.state.currentCustomer;
      newOrder.Deliver_Customer_num =  this.props.customers[index].CustomerNum;
      newOrder.Deliver_CustomerName = this.state.currentCustomerName;
      newOrder.Description = description;
	    newOrder.Deliver_CustomerAddress_id = 1;
  	  newOrder.Deliver_CustomerContact_id = 1;
  	  newOrder.Pickup_Warehouse_id =  1;
  	  newOrder.DispatchMethod_id = 1;
  	  newOrder.DispatchOutSourceContact_id = 1;
  	  newOrder.PaymentTerm_id = 1;
      newOrder.TotalPrice = this.state.totalPrice;
      newOrder.FinalWeight = this.state.finalWeight;
      if (!orderDate) {
        newOrder.OrderDate = this.formatDate(new Date);
      } else {
        newOrder.OrderDate = this.formatDate(orderDate);
      }
      newOrder.UpdateTime = this.formatDate(new Date);
      if (!dispatchDate) {
        var currentDate = new Date();
        var tomorrow = currentDate;
        tomorrow.setDate(tomorrow.getDate() + 1);
        newOrder.DispatchDate = this.formatDate(tomorrow);
      } else {
        newOrder.DispatchDate = this.formatDate(dispatchDate);
      }
      this.setState({dirty: false});
      createSalesOrder(newOrder);
    }

    handleInventoryNumKeyPress(event){
      if(event.charCode == 13){
        if (this.state.inventories.rows.length > 0) {
          let rows = this.state.inventories.rows;
          rows.map(row => {
            row.isSelected = false;
          });
          rows[0].isSelected = true;
          let inventories = {...this.state.inventories, rows: rows};
          this.setState({ inventories, cellSelectEnabled: false });
          ReactDOM.findDOMNode(this.refs["reactDataGrid"].refs.base.refs.viewPortContainer).focus();
        }
      }
    }

    checkPermission(permission) {
        return false;
    }

    render() {

        let createDialogStyle = {
            width: "700px",
            height: "650px",
            marginTop: '-300px',
            marginLeft: '-25%'
        };

        const { handleSubmit, submitting, pristine, isEditing, isCreating } = this.props;
        var currentDate = new Date();
        var tomorrow = currentDate;
        tomorrow.setDate(tomorrow.getDate() + 1);
        if (this.props.detailIsLoading && !this.props.detailError) return <ContentWrapper><br/>...reading data</ContentWrapper>
        else if (this.props.detailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            return (
                <ContentWrapper>
                    <h1>
                        {this.props.name}
                    </h1>
                    <Panel>
                        {this.title() }
                        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                            <hr/>
                            <Row>
                                <Col sm={ 4 }>
                                    <Panel>
                                        <h4><Translate value="msg_select_customer" /></h4>
                                        <hr/>
                                        {this.renderCustomers() }
                                        <br/>
                                        <Row>
                                            <label className="col-sm-5 marginTopStyle" ><Translate value="description" /></label>
                                            <Col sm={ 7 }>
                                                <Field name="CustomerDescription" component="Textarea" className="form-control" style={{ minHeight: '34px', marginBottom: 10 }}/>
                                            </Col>
                                        </Row>
                                        <Panel className="panelStyle" header={this.favoriteItemsHeader() } collapsible expanded={this.state.favoriteItemsOpen}>
                                            {this.renderFavorites()}
                                        </Panel>
                                        <Panel className="panelStyle" header={this.previousOrdersHeader() } collapsible expanded={this.state.previousOrdersOpen}>
                                            {this.renderPreviousOrders()}
                                        </Panel>
                                        <Panel className="panelStyle" header={this.promotionsHeader() } collapsible expanded={this.state.promotionsOpen}>
                                            {this.renderPromotions()}
                                        </Panel>
                                      </Panel>
                                </Col>
                                <Col sm={ 8 }>
                                    <Row><Col sm={ 12 }>
                                        <Link to="/wholesale" className="btn btn-default"><em className="fa fa-close"/></Link>
                                        { (isCreating || isEditing) && <Spinner/> }
                                        { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError) }</div> }
                                        { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError) }</div> }
                                        <Button className="btn btn-primary pull-right" disabled={ isCreating || isEditing || pristine || (this.state.currentCustomer == null) || (this.state.rows == 0) } onClick={() => {this.addNewSalesOrder()}} ><em className="fa fa-save marginRightStyle" /><Translate value="save" /></Button>
                                        <Button className="btn btn-primary pull-right" disabled={ isCreating || isEditing || pristine } ><Translate value="print" /></Button>
                                    </Col></Row>
                                    <hr/>
                                    <Panel>
                                        <Row>
                                            <Col sm={ 12 }>
                                                <div className="form-group">
                                                    <Row>
                                                      <Col sm={ 3 }>
                                                        <h4><Translate value="product_detail" /></h4>
                                                      </Col>
                                                      <Col sm={ 3 }>
                                                          <label><Translate value="document_date" /></label>
                                                          <Field name="DocumentDate" selected={new Date} component={ DisabledDatePicker }/>
                                                      </Col>
                                                      <Col sm={ 3 }>
                                                          <label><Translate value="order_date" /></label>
                                                          <Field name="WholesaleOrderDate" selected={new Date} component={ DatePicker }/>
                                                      </Col>
                                                      <Col sm={ 3 }>
                                                          <label><Translate value="dispatch_date" /></label>
                                                          <Field name="DispatchDate" selected={tomorrow} component={ DatePicker }/>
                                                      </Col>
                                                    </Row>
                                                    <hr/>
                                                    <Row>
                                                        <Col sm={ 12 }>
                                                            {this.renderInventories() }
                                                            <br/>
                                                            <hr/>
                                                            {this.renderSelectedItem() }
                                                            <Row>
                                                              <Col sm={ 8 }/>
                                                              <Col sm={ 2 }>
                                                                <Button ref={(button) => { this.chooseFromBatch = button }} className="btn btn-primary pull-right" disabled={!this.state.selectedItemNumber} onClick={() => this.openChooseFromBatch()}>
                                                                <Translate value="msg_select_from_batch" /></Button>
                                                              </Col>
                                                              <Col sm={ 2 }>
                                                                <Button className="btn btn-danger pull-right" onClick={() => this.removeFromSO() }
                                                                  disabled={this.state.selectedRows > 0}><em/><Translate value="remove_from_so_list" /></Button>
                                                              </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <hr/>
                                                    {this.renderTable() }
                                                    <hr/>
                                                    <Row>
                                                      <Col sm={ 6 }>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="total_price" /></label>
                                                          </Col>
                                                          <Col sm={ 6 }>
                                                            <label>{this.state.totalPrice}</label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="tax" /></label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="final_dollarsign" /></label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="final_weight" /></label>
                                                          </Col>
                                                          <Col sm={ 6 }>
                                                            <label>{this.state.finalWeight}</label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="profit" /></label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="profit_percentage" /></label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col sm={ 6 }>
                                                            <label><Translate value="payment_term" /></label>
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                    <h4><Translate value="shipping" /></h4>
                                                    <hr/>
                                                    <Row>
                                                      <Col sm={ 6 }>
                                                       <Row>
                                                         <Col sm={ 6 }>
                                                           <label><Translate value="shipping_address" /></label>
                                                         </Col>
                                                       </Row>
                                                      </Col>
                                                    </Row>
                                                    <Row>
                                                      <Col sm={ 6 }>
                                                       <Row>
                                                         <Col sm={ 6 }>
                                                           <label><Translate value="transit_method" /></label>
                                                         </Col>
                                                       </Row>
                                                      </Col>
                                                    </Row>
                                                    <Row>
                                                      <Col sm={ 6 }>
                                                       <Row>
                                                         <Col sm={ 6 }>
                                                           <label><Translate value="scheduling_shipping_date" /></label>
                                                         </Col>
                                                       </Row>
                                                      </Col>
                                                    </Row>
                                                    <Row>
                                                      <Col sm={ 6 }>
                                                       <Row>
                                                         <Col sm={ 6 }>
                                                           <label><Translate value="shipment_date" /></label>
                                                         </Col>
                                                       </Row>
                                                      </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Panel>
                                </Col>
                            </Row>
                            <Row>
                            </Row>
                            { this.props.isCreating || this.props.isEditing && <Spinner/> }
                            { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
                            { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }
                        </form>
                        <SkyLightStateless isVisible={this.state.customerOpen} onCloseClicked={() => { this.closeCustomer() } } title="Add A New Payment Term">
                            <CustomerForm closePT={this.closeCustomer} />
                        </SkyLightStateless>
                        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.batchOpen} onCloseClicked={() => {
                            this.closeChooseFromBatch()
                        } } title="Choose From Batch" className="wholesaleModal">
                            <WholesaleModal ProductNum={this.state.selectedItemNumber} closeC={this.closeChooseFromBatch} moveToSO={(this.moveToSO)} />
                        </SkyLightStateless>
                    </Panel>
                </ContentWrapper >
            )
        }
    }
}

export default withRouter(WholesaleOrderForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/wholesaleOrderForm.jsx